import React, { useEffect } from "react";
import cookies from "js-cookie";
import { languages } from "./data";
import Configurations from "./configurations/Configurations";
import { loadUser } from "./redux/actions/userActions";
import { useDispatch } from "react-redux";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  const currentLanguageCode = cookies.get("i18next") || "en";
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode);

  useEffect(() => {}, [currentLanguage]);

  return (
    <>
      <Configurations />
    </>
  );
}

export default App;
